











































import NoteModel from "@/ts/models/noteClass";
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch
} from "@vue/composition-api";
import NoteCard from "../../molecules/note/NoteCard.vue";
import CurrentOutlined from "@c/molecules/current/CurrentOutlined.vue";
import Draggable from "vuedraggable";

export default defineComponent({
  components: {
    NoteCard,
    CurrentOutlined,
    Draggable
  },

  props: {
    notes: {
      type: Array as () => Array<NoteModel>,
      default: () => []
    },
    label: {
      type: String,
      default: "Notes"
    },
    loading: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    }
  },

  name: "",

  setup(props, { emit }) {
    var compNotes = ref<Array<NoteModel>>([]);

    const setNotes = (notes: Array<NoteModel>) => {
      compNotes.value = JSON.parse(JSON.stringify(notes));
    };

    onMounted(() => {
      setNotes(props.notes);
    });

    watch(
      () => props.notes,
      newValue => {
        setNotes(newValue);
      }
    );

    var drag = ref(false);

    var dragOptions: any = computed(() => {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    });

    const close = (index: number) => {
      const note = compNotes.value[index];
      emit("removeNote", index);
    };

    return {
      drag,
      dragOptions,
      compNotes,
      close
    };
  }
});
